import React from "react";
import './SIRENField.css';
import ReactInput from "../../../services/packages/input-format/react/Input";
import {remFromPx} from "../../../services/utils/ui-commons";
import {DARK_BLUE_COLOR} from "../../../services/utils/colors";

function electronicFormatSIREN(siren) {
    if (typeof siren !== 'string') {
        return null;
    }
    return siren.replace(/[-\ ]/g, '').toUpperCase();
}


export function friendlyFormatSIREN(siren, separator) {
    if (typeof siren !== 'string') {
        return null;
    }
    if (separator === undefined || separator === null) {
        separator = ' ';
    }
    var electronic_siren = electronicFormatSIREN(siren);
    /* istanbul ignore if */
    if (electronic_siren === null) {
        return null;
    }
    return electronic_siren.replace(/(.{3})(?!$)/g, '$1' + separator);
}

const formatSIRENValue =  value => {
    let text = '';

    text=friendlyFormatSIREN(value,' ');
    // let rawText=ibantools.electronicFormatIBAN(value);
    return { text, template: '',editableLength:text.length}
};

function parseSIRENCharacter(character, value)
{
    if  ('0123456789'.indexOf(character) !== -1) {
        return character
    }
    else {
        return
    }
}

/**
 * Input field for SIREN
 */
export class SIRENField extends React.Component {

    constructor(props) {
        super(props);
        this.valueFormatter = this.props.valueFormatter===undefined ? formatSIRENValue : this.props.valueFormatter;
        this.state = {
            formattedText:''
        }
    }

    componentDidUpdate(prevProps, prevState) {


        const formattedValue = this.valueFormatter(this.props.state);
        const formattedText = formattedValue.text;
        let selectionPosition=0;
        selectionPosition=formattedValue.editableLength;
        if ((prevProps.focus !== this.props.focus) || (!this.focusSet) ) {
            if (this.props.focus) {
                this.inputRef.focus();

                // setTimeOut Obligatoire sous Android
                setTimeout(() => {
                        const inputRef = this.inputRef;
                        if (inputRef !== null) {
                            inputRef.setSelectionRange(selectionPosition, selectionPosition);
                        }
                    }
                    , 5);

                //  this.inputRef.input.selectionStart = this.inputRef.input.selectionEnd = selectionPosition;
            }
        }
        this.focusSet=true;

        if (formattedText!==this.state.formattedText) {
            // on force le curseur à la fin de la zone de saisie : le timeout permet de contourner un bug dans Android
            setTimeout(() => this.inputRef.setSelectionRange(selectionPosition, selectionPosition), 5);
            this.setState({...this.state,formattedText});
        }


    }

    render() {
        const context = this.props.context;
        const state = this.props.state;
        const isPhone = context.appContext.isPhone;

        const style = {
            //borderBottom: this.props.enabled ? '1px solid #002538' : '1px solid #8C8C8C',
            width:'100%',
        };

        const fontSize= this.props.fontSize===undefined ? remFromPx(15) : this.props.fontSize;

        const inputStyle = {
            fontFamily: 'WorkSansVariableFont',
            fontVariationSettings: '"wght" 400',
            fontSize: fontSize,
            backgroundColor: 'transparent',
            borderStyle: 'none',
            width: '100%',
            outline: 'none',
            textAlign:'left',
            margin: 0,
            color:this.props.color!==undefined ? this.props.color : DARK_BLUE_COLOR
        };

        const onInputRef = (input) => {
            this.inputRef = input;
        };

        const onChange = value => {
            context.dispatch(this.props.createOnChangeAction(value));
        };

        const onFocus = (e) => {
            if (this.props.onFocusAction) {
                context.dispatch(this.props.onFocusAction);
            }
            else {
                if (this.props.onFocus) {
                    this.props.onFocus();
                }
            }

        };

        this.focusSet = false;

        const readonly = this.props.readonly!==undefined ? this.props.readonly : false;
        const inputClass = this.props.inputClass!==undefined ? this.props.inputClass : 'SIRENInputClass';

        return (
            <div style={style}>
                <ReactInput className={inputClass}
                            style={inputStyle}
                            type='text' value={state}
                            placeholder={this.props.placeholder}
                            ref={onInputRef}
                            onFocus={onFocus}
                            onChange={onChange}
                            disabled={!this.props.enabled}
                            readOnly={readonly}
                            parse={parseSIRENCharacter}
                            autoComplete='off'
                            pattern={isPhone ? '[0-9]*' : undefined}
                            inputMode={isPhone ? 'numeric' : undefined}
                            format={this.valueFormatter}/>
            </div>
        );
    }
}
